<template>
  <div class="top">
    <div class="big_title">联系我们</div>
    <div class="box">
      <div class="left_info">
        <div class="titleBox">
          <div class="title">{{ lxwmInfor.title }}</div>
        </div>
        <div class="address firstSty">地址：{{ lxwmInfor.address }}</div>
        <div class="address">邮编：{{ lxwmInfor.zipcode }}</div>
        <div class="address">电话：{{ lxwmInfor.tel }}</div>
        <div class="address">传真：{{ lxwmInfor.fax }}</div>
        <div class="address">E-mail：{{ lxwmInfor.email }}</div>
      </div>
      <div class="right_map">
        <img :src="mapImage" alt="地图" class="map-image" />
      </div>
    </div>
  </div>
</template>
<script setup>
import { onMounted, ref } from "vue";
import api from "@/api/api";
import mapImage from "@/assets/home/map-placeholder2.jpg";
const lxwmInfor = ref({});
const getlxwmInfor = () => {
  const resourceId = 83;
  api.getPageConfigDetail(resourceId).then((res) => {
    if (res.code === "0" && res.res.data) {
      lxwmInfor.value = res.res.data;
    }
  });
};
onMounted(() => {
  getlxwmInfor();
});
</script>
<style lang="less" scoped>
.map-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.big_title {
  height: 5.27vh;
  font-weight: 600;
  font-size: 48px;
  line-height: 5.27vh;
  text-align: left;
  font-style: normal;
  color: #333333;
  margin-bottom: 3.38vh;
  font-family: PingFangSC, PingFang SC;
}
.box {
  display: flex;
  align-items: center;
  width: 100%;
  height: 421px;
  background: #f9f9f9;
  padding: 77px 5.2vw;
  box-sizing: border-box;
  .left_info {
    width: 550;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-top: 6px;
    .titleBox {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      margin: 6px 0px 30px 0px;
      .title {
        font-family: SourceHanSansCN, SourceHanSansCN;
        font-weight: bold;
        font-size: 36px;
        color: #333333;
        height: 44px;
      }
    }
    .address {
      font-family: SourceHanSansCN, SourceHanSansCN;
      font-weight: 400;
      font-size: 20px;
      color: #333333;
      line-height: 30px;
      text-align: left;
      font-style: normal;
      margin-bottom: 6px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
    }
  }
  .right_map {
    flex: 1;
    border: 1px solid #a2a2a2;
    height: 276px;
    margin-left: 20px;
  }
}
</style>
